<script setup lang="ts">
import { safeBadgeIconUrl } from '../creator/contracts.mjs';
import { badgeArtwork } from '../creator/badges/badge-art.mjs';
import artwork from '../creator/badges/badge-art-v5.json';

const props = defineProps<{ icon: string; label: string; src?: string; apiBase?: string }>();
const primary = computed(() => safeBadgeIconUrl(props.src, props.apiBase));
const fallback = computed(() => badgeArtwork(artwork, props.icon, 1));
const failed = ref(false);
watch(primary, () => { failed.value = false; });
const source = computed(() => !failed.value && primary.value || fallback.value);
</script>

<template>
  <img v-if="source" class="creator-badge challenge-badge" :src="source" :alt="label" width="72" height="72" decoding="async" referrerpolicy="no-referrer" @error="failed = true">
</template>

<style scoped>
.challenge-badge { display: block; width: 72px; height: 72px; object-fit: contain; flex-shrink: 0; }
</style>
